export default "__VITE_ASSET__DSkbCjsJ__"